import React from "react";
import { Star } from "lucide-react";

const StatsSection = () => {
  const sectionStyle = {
    padding: "4rem 0",
    background: "linear-gradient(135deg, #000000, #0891b2)",
    color: "white",
  };

  const containerStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 1.5rem",
  };

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "2rem",
    textAlign: "center",
  };

  const statStyle = {
    padding: "1.5rem",
  };

  const numberStyle = {
    fontSize: "3rem",
    fontWeight: "bold",
    color: "#22d3ee",
    marginBottom: "0.5rem",
  };

  const ratingStyle = {
    fontSize: "3rem",
    fontWeight: "bold",
    color: "#22d3ee",
    marginBottom: "0.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
    flexWrap: "wrap",
  };

  const starsContainerStyle = {
    display: "flex",
    gap: "0.25rem",
    marginTop: "0.5rem",
  };

  const labelStyle = {
    color: "#e0e0e0",
    fontSize: "1.1rem",
  };

  const StarRating = () => (
    <div style={ratingStyle}>
      <span>4.9</span>
      <div style={starsContainerStyle}>
        <Star size={24} fill="#22d3ee" color="#22d3ee" />
      </div>
    </div>
  );

  const stats = [
    { number: "15+", label: "Years Experience" },
    { number: "5000+", label: "Balls Drilled" },
    { number: "10+", label: "Top Brands" },
    {
      component: <StarRating />,
      label: "Google Review Rating",
    },
  ];

  return (
    <section style={sectionStyle}>
      <div style={containerStyle}>
        <div style={gridStyle}>
          {stats.map((stat, index) => (
            <div key={index} style={statStyle}>
              {stat.component ? (
                stat.component
              ) : (
                <div style={numberStyle}>{stat.number}</div>
              )}
              <div style={labelStyle}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
